import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IMaintenanceState } from './maintenance.types';
import { IMaintenanceData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IMaintenanceState = {
  version: 1,
  maintenances: [] as IMaintenanceData[],
  lastPromise: null
};

const namespaced = true;

export const maintenance: Module<IMaintenanceState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
